import msi from "./index.web";
export default msi;
